var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7095 40.2495V53.9396",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7095 18V30.8401",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0002 27.4106V53.9408",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2908 46.2402V53.9402",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2908 18V36.8301",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 27.4201C38.6019 27.4201 40.7106 25.3113 40.7106 22.71C40.7106 20.1087 38.6019 18 36.0006 18C33.3993 18 31.2905 20.1087 31.2905 22.71C31.2905 25.3113 33.3993 27.4201 36.0006 27.4201Z",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7101 40.2502C23.3113 40.2502 25.4201 38.1414 25.4201 35.5401C25.4201 32.9389 23.3113 30.8301 20.7101 30.8301C18.1088 30.8301 16 32.9389 16 35.5401C16 38.1414 18.1088 40.2502 20.7101 40.2502Z",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2896 46.2419C53.8909 46.2419 55.9996 44.1331 55.9996 41.5318C55.9996 38.9306 53.8909 36.8218 51.2896 36.8218C48.6883 36.8218 46.5796 38.9306 46.5796 41.5318C46.5796 44.1331 48.6883 46.2419 51.2896 46.2419Z",
    stroke: "#0A090A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersicon);
export default __webpack_public_path__ + "static/media/filtersicon.efe1438b683514f9f3bca509b46925eb.svg";
export { ForwardRef as ReactComponent };